/* Brennholzrechner (snippets/product-firewood-calculator.liquid)
 *
 * Rechenmodell
 *   Modus "haus":   Jahreswaerme = Wohnflaeche x Kennwert(Daemmstandard) [kWh/m2*a]
 *                   Waerme aus Holz = Jahreswaerme x Holzanteil
 *   Modus "ofen":   Waerme aus Holz = Ofenleistung x Stunden x Abende x Wochen
 *   beide:          Holzenergie = Waerme aus Holz / Wirkungsgrad
 *                   Menge       = Holzenergie / Energiegehalt je Verkaufseinheit
 *                   Bestellmenge = aufgerundet auf ganze Einheiten
 *
 * Bewusst NICHT enthalten: ein Regler fuer die Holzfeuchte. Pro Raummeter ist die
 * Trockenmasse konstant, deshalb aendert die Feuchte den Energiegehalt je
 * Raummeter nur um wenige Prozent (0 % -> 25 % Wassergehalt ca. 4 %). Ein
 * prominenter Regler wuerde eine Genauigkeit vortaeuschen, die es nicht gibt.
 */
(function () {
  if (customElements.get('firewood-calculator')) return;

  var supportsModal = typeof HTMLDialogElement !== 'undefined'
    && typeof HTMLDialogElement.prototype.showModal === 'function';

  var nf0 = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });
  var nf1 = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

  // 1 -> "1", 1.5 -> "1,5"
  function unitNum(n) {
    return Number.isInteger(n) ? nf0.format(n) : nf1.format(n);
  }

  /* Gemeinsame Scroll-Sperre.
   *
   * NICHT body.style.overflow anfassen: assets/vendor.js (die Drawer-/Cart-
   * Sperre des Themes) schreibt denselben Inline-Style und merkt sich dessen
   * vorherigen Wert. Zwei unabhaengige Schreiber ueberschreiben sich
   * gegenseitig - oeffnet sich ein Drawer, waehrend unser Popup offen ist,
   * merkt sich vendor.js "hidden" als Ausgangswert und stellt das beim
   * Schliessen wieder her: die Seite bleibt dauerhaft ungescrollt.
   *
   * Stattdessen eine eigene Klasse mit Zaehler. vendor.js behaelt seinen
   * Inline-Wert, wir entfernen beim Freigeben nur unsere Klasse.
   */
  var scrollLock = window.__kbScrollLock || (function () {
    var CLASS = 'kb-scroll-locked';
    var STYLE_ID = 'kb-scroll-lock-style';
    var holders = 0;

    function ensureStyle() {
      if (document.getElementById(STYLE_ID)) return;
      var style = document.createElement('style');
      style.id = STYLE_ID;
      // !important, damit ein spaeter gesetzter Inline-Style die Sperre nicht aufhebt.
      style.textContent = 'html.' + CLASS + ',html.' + CLASS + '>body{overflow:hidden!important}';
      (document.head || document.documentElement).appendChild(style);
    }

    var api = {
      lock: function () {
        ensureStyle();
        holders += 1;
        document.documentElement.classList.add(CLASS);
      },
      release: function () {
        holders = Math.max(0, holders - 1);
        if (holders === 0) document.documentElement.classList.remove(CLASS);
      }
    };

    window.__kbScrollLock = api;
    return api;
  })();

  function num(value, fallback) {
    var n = parseFloat(value);
    return isFinite(n) ? n : fallback;
  }

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  class FirewoodCalculator extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.fc-dialog');
      this.form = this.querySelector('.fc-form');
      if (!this.dialog || !this.form) return;

      this.config = {
        kwhPerUnit: num(this.dataset.kwhPerUnit, 1900),
        unitLabel: this.dataset.unitLabel || 'RM',
        unitSize: num(this.dataset.unitSize, 1),
        maxUnits: num(this.dataset.maxUnits, 60),
        currency: this.dataset.currency || 'EUR'
      };

      try {
        this.prices = JSON.parse(this.dataset.prices || '{}');
      } catch (e) {
        this.prices = {};
      }

      this.money = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: this.config.currency
      });

      if (!supportsModal) this.dialog.setAttribute('data-fallback', '');

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.form.addEventListener('input', this.onInput);
      this.form.addEventListener('change', this.onInput);
      this.form.addEventListener('submit', function (e) { e.preventDefault(); });

      this.syncMode();
      this.calculate();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.unlockScroll();
    }

    /* --- Interaktion ----------------------------------------------------- */

    onClick = (event) => {
      if (event.target.closest('[data-fc-open]')) {
        this.open();
        return;
      }
      if (event.target.closest('[data-fc-close]')) {
        this.close();
        return;
      }
      if (event.target.matches('dialog.fc-dialog')) {
        this.close();
        return;
      }

      var step = event.target.closest('[data-fc-step]');
      if (step) {
        this.stepNumber(step);
        return;
      }

      if (event.target.closest('[data-fc-apply]')) this.apply();
    };

    onKeydown = (event) => {
      if (event.key !== 'Escape' || supportsModal) return;
      if (this.dialog.hasAttribute('open')) this.close();
    };

    onInput = () => {
      this.syncMode();
      this.calculate();
    };

    stepNumber(button) {
      var input = this.form.querySelector('#' + button.getAttribute('data-fc-step'));
      if (!input) return;
      var delta = num(button.getAttribute('data-fc-delta'), 1);
      var min = num(input.min, 0);
      var max = num(input.max, Infinity);
      input.value = clamp(num(input.value, min) + delta, min, max);
      this.calculate();
    }

    syncMode() {
      var mode = this.mode();
      this.querySelectorAll('[data-fc-mode-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-fc-mode-panel') !== mode;
      });
    }

    mode() {
      var checked = this.form.querySelector('input[name="fc-mode"]:checked');
      return checked ? checked.value : 'haus';
    }

    field(name, fallback) {
      var el = this.form.querySelector('[name="' + name + '"]:checked')
        || this.form.querySelector('[name="' + name + '"]');
      return el ? num(el.value, fallback) : fallback;
    }

    /* --- Rechnung -------------------------------------------------------- */

    calculate() {
      var heatFromWood;

      if (this.mode() === 'ofen') {
        var kw = clamp(this.field('fc-stove-kw', 7), 2, 20);
        var hours = clamp(this.field('fc-hours', 4), 1, 12);
        var evenings = clamp(this.field('fc-evenings', 3), 1, 7);
        var months = clamp(this.field('fc-months', 6), 1, 12);
        heatFromWood = kw * hours * evenings * (months * 4.33);
      } else {
        var area = clamp(this.field('fc-area', 120), 10, 1000);
        var perSqm = this.field('fc-insulation', 100);
        var share = this.field('fc-share', 70) / 100;
        heatFromWood = area * perSqm * share;
      }

      var efficiency = clamp(this.field('fc-efficiency', 75), 40, 95) / 100;
      var woodEnergy = heatFromWood / efficiency;

      var unitsExact = woodEnergy / this.config.kwhPerUnit;
      var units = clamp(Math.ceil(unitsExact), 1, this.config.maxUnits);
      var capped = Math.ceil(unitsExact) > this.config.maxUnits;

      this.render({
        heatFromWood: heatFromWood,
        unitsExact: unitsExact,
        units: units,
        capped: capped
      });
    }

    /* --- Ausgabe --------------------------------------------------------- */

    render(r) {
      var cfg = this.config;
      var volumeExact = r.unitsExact * cfg.unitSize;
      var volumeOrdered = r.units * cfg.unitSize;
      // Meter: Anteil des rechnerischen Bedarfs an der aufgerundeten Bestellmenge.
      var fill = volumeOrdered > 0 ? clamp((volumeExact / volumeOrdered) * 100, 0, 100) : 0;

      this.set('[data-fc-out="units"]', nf0.format(r.units));
      this.set('[data-fc-out="unit-label"]',
        '× ' + unitNum(cfg.unitSize) + ' ' + cfg.unitLabel);
      this.set('[data-fc-out="need"]', nf1.format(volumeExact) + ' ' + cfg.unitLabel);
      this.set('[data-fc-out="ordered"]', nf1.format(volumeOrdered) + ' ' + cfg.unitLabel);
      this.set('[data-fc-out="energy"]', nf0.format(Math.round(r.heatFromWood / 10) * 10) + ' kWh');

      var reserve = volumeOrdered - volumeExact;
      this.set('[data-fc-out="reserve"]',
        nf1.format(Math.max(0, reserve)) + ' ' + cfg.unitLabel + ' Reserve');

      this.querySelectorAll('[data-fc-out="meter"]').forEach(function (el) {
        el.style.width = fill.toFixed(1) + '%';
      });

      var meterWrap = this.querySelector('[data-fc-meter]');
      if (meterWrap) {
        meterWrap.setAttribute('aria-label',
          'Bedarf ' + nf1.format(volumeExact) + ' ' + cfg.unitLabel +
          ' von ' + nf1.format(volumeOrdered) + ' ' + cfg.unitLabel + ' Bestellmenge');
      }

      // Preis nur zeigen, wenn er sicher bestimmbar ist.
      var priceRow = this.querySelector('[data-fc-price-row]');
      var unitPrice = this.currentUnitPrice();
      if (priceRow) {
        if (unitPrice === null) {
          priceRow.hidden = true;
        } else {
          priceRow.hidden = false;
          this.set('[data-fc-out="price"]', this.money.format(unitPrice * r.units / 100));
        }
      }

      var hasQty = !!this.quantityInput();
      var applyText = nf0.format(r.units) + ' '
        + (r.units === 1 ? 'Einheit' : 'Einheiten') + ' übernehmen';
      this.querySelectorAll('[data-fc-apply]').forEach(function (el) {
        el.textContent = el.hasAttribute('data-fc-apply-short') ? 'Übernehmen' : applyText;
        el.disabled = !hasQty;
      });

      var note = this.querySelector('[data-fc-out="cap"]');
      if (note) note.hidden = !r.capped;

      var live = this.querySelector('.fc-live');
      if (live) {
        live.textContent = 'Empfehlung: ' + nf0.format(r.units) + ' '
          + (r.units === 1 ? 'Einheit' : 'Einheiten') + ', '
          + nf1.format(volumeOrdered) + ' ' + cfg.unitLabel + '.';
      }

      this.lastUnits = r.units;
    }

    set(selector, text) {
      // querySelectorAll: Hero und mobile Leiste zeigen dieselben Werte.
      this.querySelectorAll(selector).forEach(function (el) { el.textContent = text; });
    }

    currentUnitPrice() {
      var ids = Object.keys(this.prices);
      if (!ids.length) return null;
      var input = document.querySelector('product-form input[name="id"]')
        || document.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = input && input.value;
      if (id && Object.prototype.hasOwnProperty.call(this.prices, id)) return this.prices[id];
      return ids.length === 1 ? this.prices[ids[0]] : null;
    }

    /* --- Menge in das Produktformular uebernehmen ------------------------ */

    quantityInput() {
      return document.querySelector('.quantity__input[name="quantity"]')
        || document.querySelector('input[name="quantity"]');
    }

    apply() {
      var input = this.quantityInput();
      if (!input || !this.lastUnits) return;

      var max = num(input.max, Infinity);
      input.value = Math.min(this.lastUnits, max);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));

      this.close();

      // Der Kunde soll sehen, wo die Menge gelandet ist.
      requestAnimationFrame(function () {
        input.scrollIntoView({ block: 'center', behavior: 'smooth' });
        try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
      });
    }

    /* --- Dialog ---------------------------------------------------------- */

    lockScroll() {
      if (this.locked) return;
      this.locked = true;
      scrollLock.lock();
    }

    unlockScroll() {
      if (!this.locked) return;
      this.locked = false;
      scrollLock.release();
    }

    open() {
      if (this.dialog.open) return;
      this.opener = this.querySelector('[data-fc-open]');
      this.lockScroll();
      this.calculate();

      if (supportsModal) {
        this.dialog.addEventListener('close', this.onDialogClose, { once: true });
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
        var first = this.dialog.querySelector('[data-fc-close]');
        if (first) first.focus();
      }
    }

    close() {
      if (supportsModal) {
        if (this.dialog.open) this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
        this.onDialogClose();
      }
    }

    onDialogClose = () => {
      this.unlockScroll();
      if (this.opener && this.contains(this.opener)) this.opener.focus();
      this.opener = null;
    };
  }

  customElements.define('firewood-calculator', FirewoodCalculator);
})();
